"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = __importDefault(require("~pages/api"));
const article_1 = __importDefault(require("~pages/knowledge-base/article"));
exports.default = {
    api: api_1.default,
    'knowledge-base-article': article_1.default,
};
